import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { BotControllerApi } from 'api/controllers/bot-controller-api';
import { ErrorResponseCode } from 'api/models/error-response-code';
import { errorNotification } from 'components/Snackbar';
import { useTelegramUser } from 'hooks/useTelegramUser';
import { getErrorCodeMessage } from 'pages/Checkout/utils';
import { QueryKeys } from 'utils/queryKeys';

export const useGetOrderApi = (dayDate?: string) => {
  const { t } = useTranslation();
  const user = useTelegramUser();
  const userId = user?.id;

  const orderResponse = useQuery(
    [QueryKeys.GET_ORDER_BY_DAY, dayDate, userId],
    () =>
      // Must match the Checkout page's endpoint: both share this query key, so mixing the legacy
      // getOrder (GoogleMenuItem shape) here with getOrder_next there made the cached order items
      // lose their next-stack `product` (name/weight/image) when checkout was opened from Week.
      BotControllerApi.getOrder_next({
        telegramId: userId as number,
        localDate: dayDate as string,
      }),
    {
      onError: (err: AxiosError) => {
        const { code, status } = err?.response?.data as unknown as {
          status: number;
          code: ErrorResponseCode;
        };

        if (err.response?.status === 404 || status === 404) {
          return;
        }

        errorNotification(t(getErrorCodeMessage({ code })));
      },
      enabled: !!userId && !!dayDate,
    },
  );

  return {
    isLoading: orderResponse.isLoading,
    isError: orderResponse.isError,
    order: orderResponse.data?.data,
    totalAmount: orderResponse.data?.data.totalAmount,
    orderResponse,
  };
};
